import { Permission } from './permissions';

export interface NavItem {
  label: string;
  /** router path without a leading slash; omit for a not-yet-built entry */
  path?: string;
  icon: string;
  permission?: string;
  /** visible if the user holds ANY of these — for a page that aggregates entities */
  anyPermission?: string[];
  soon?: boolean;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

/**
 * Single source of truth for the sidebar AND route-level permission guarding —
 * `layout.component.ts` renders from this, `app.routes.ts` derives each route's
 * `data.permission`/`data.anyPermission` from this, so the two can't drift apart.
 */
export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Monitor',
    items: [
      {
        label: 'Command Dashboard',
        path: 'dashboard',
        icon: 'dashboard',
        permission: Permission.Listing.Read,
      },
      {
        label: 'Fleet & Vehicles',
        path: 'vehicles/listings',
        icon: 'car',
        permission: Permission.Listing.Read,
      },
      {
        label: 'Trip History',
        path: 'trips',
        icon: 'compass',
        permission: Permission.Booking.Read,
      },
    ],
  },
  {
    label: 'Manage',
    items: [
      {
        label: 'Users',
        path: 'users',
        icon: 'user',
        anyPermission: [Permission.User.Read, Permission.Kyc.Read],
      },
      {
        label: 'Zones & Geofencing',
        path: 'zones',
        icon: 'environment',
        permission: Permission.Zone.Read,
      },
      {
        label: 'Vehicle Catalog',
        path: 'vehicles/catalog',
        icon: 'appstore',
        anyPermission: [Permission.Listing.Read, Permission.Car.Read, Permission.Brand.Read],
      },
      {
        label: 'Audit Trail',
        path: 'audit-trail',
        icon: 'audit',
        permission: Permission.ActivityLog.Read,
      },
    ],
  },
  {
    label: 'Configure',
    items: [
      { label: 'Roles', path: 'roles', icon: 'tool', permission: Permission.Role.Read },
      {
        label: 'Groups',
        path: 'groups',
        icon: 'team',
        permission: Permission.Group.Read,
      },
      {
        label: 'KYC Types',
        path: 'kyc/types',
        icon: 'solution',
        permission: Permission.KycType.Read,
      },
    ],
  },
];
